import { getTopFiveLeagues } from "../../js/api/topfiveleague.js";
import { getTopTenMatchGames } from "../../js/api/toptenprematchgames.js";
import { getTopTenLiveGames } from "../../js/api/toptenlivegames.js";
import { sports } from "../components/Leftpanel.js";
import { getTopTenLiveTemplate } from "../templates/top-ten-live-games.js";
import {
  getFeaturedMatches,
  getTodayMatches,
} from "../../js/api/featuredPreMatch.js";
import { getPrematchGamesMainLeague } from "../../js/api/mainLeagueMatch.js";
import { getLiveTemplate } from "../templates/live-games.js";
import { _t } from "../../services/TranslationService.js";
import {
  getPokerUrl,
  isEuroVegasDomain,
  LOGIN_PROTECTED,
} from "../../js/constants/global-variables.js";

let timers = [];

function renderFeaturedMatch(match) {
  if (!match || !match.odd) return "";

  try {
    const odds = match.odd.split(",").map((odd) => odd.split("|"));
    if (odds.length < 3) return "";

    const date = new Date(match.game_date);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const time = `${match.game_time.split(":")[0]}:${match.game_time.split(":")[1]}`;

    const renderOdd = (odd, className, option) => {
      const oddValue = (
        Math.floor((parseFloat(odd[1]) + Number.EPSILON) * 100) / 100
      ).toFixed(2);
      const market = ["1", "X", "2"].includes(odd[2])
        ? "Rezultat final"
        : odd[2];

      return `<div class="${className} bettingBtn ${oddValue == 1 ? "disabledBtn" : ""} ${odd[0]}" match-odd="${oddValue}" match-home-name="${match.home_team}" match-away-name="${match.away_team}" match-market="${market}" coef-id="${odd[0]}" match-market-option="${option} " bet-id="${odd[0]}" game-id="${match.id}"><i>${option}</i><i>${oddValue}</i></div>`;
    };

    return `
      <div class="featuredPrematchItem">
        <a href="#/Match/${match.id}" class="featuredMatchName">
          <span>
            <span class="kfm-Competitor_TeamKit">
              <object data="${window.location.pathname}img/kit-black.svg" type="image/svg">
                <img class="ml-TeamKit_SVG" src="${window.location.pathname}img/kit-black.svg" />
              </object>
            </span>
            <span class="featuredTeamName">${match.home_team}</span>
          </span>
          <span>
            <span class="kfm-Competitor_TeamKit">
              <object data="${window.location.pathname}img/kit-yellow.svg" type="image/svg">
                <img class="ml-TeamKit_SVG" src="${window.location.pathname}img/kit-yellow.svg" />
              </object>
            </span>
            <span class="featuredTeamName">${match.away_team}</span>
          </span>
        </a>
        <span class="featurePreMatchDate">${day}/${month} ${time}</span>
        <span class="numberofmarkets">${match.count_options} ></span>
        <div class="featuredMatchBtn">
          ${renderOdd(odds[0], "singleHomeOdd", "1")}
          ${renderOdd(odds[1], "singleDrawOdd", "X")}
          ${renderOdd(odds[2], "singleAwayOdd", "2")}
        </div>
      </div>`;
  } catch (error) {
    return "";
  }
}

function renderPrematchTableMatch(match) {
  if (!match || !match.odd) return "";

  try {
    const odds = match.odd.split(",").map((odd) => odd.split("|"));
    if (odds.length < 3) return "";

    const timeParts = (match.game_time || "").split(":");
    const time = `${timeParts[0] || "--"}:${timeParts[1] || "--"}`;

    const renderOdd = (odd, className, option) => {
      const oddValue = (
        Math.floor((parseFloat(odd[1]) + Number.EPSILON) * 100) / 100
      ).toFixed(2);
      const market = ["1", "X", "2"].includes(odd[2])
        ? "Rezultat Final"
        : odd[2];

      return `<div class="${className} bettingBtn ${oddValue == 1 ? "disabledBtn" : ""} ${odd[0]}" match-odd="${oddValue}" match-home-name="${match.home_team}" match-away-name="${match.away_team}" match-market="${market}" match-market-option="${option} " coef-id="${odd[0]}" bet-id="${odd[0]}" game-id="${match.id}">${oddValue}</div>`;
    };

    return `
      <div class="singleGameContent">
        <a class="singleTeamNames" href="#/Match/${match.id}" data-id="${match.id}">
          <div class="singleDateColumn">
            <span>${time}</span>
            <span class="numberofmarkets">${match.count_options} ></span>
          </div>
          <div class="singleDetailsColumn">
            <div class="singleTeamRowLabel">
              <span class="singleHomeName">${match.home_team}</span>
              <span class="gameSingleHomeScore"></span>
            </div>
            <div class="singleTeamRowLabel">
              <span class="singleAwayName">${match.away_team}</span>
              <span class="gameSingleAwayScore"></span>
            </div>
          </div>
        </a>
        ${renderOdd(odds[0], "singleHomeOdd", "1")}
        ${renderOdd(odds[1], "singleDrawOdd", "X")}
        ${renderOdd(odds[2], "singleAwayOdd", "2")}
      </div>`;
  } catch (error) {
    return "";
  }
}

function renderTodayMatchesByLeague(matches) {
  const matchesByLeague = new Map();

  matches.forEach((match) => {
    if (!match) return;

    const leagueKey = String(match.league_id ?? match.league ?? "");

    if (!matchesByLeague.has(leagueKey)) {
      matchesByLeague.set(leagueKey, {
        name: match.league || _t("Soccer"),
        matches: [],
      });
    }

    matchesByLeague.get(leagueKey).matches.push(match);
  });

  return Array.from(matchesByLeague.values())
    .map((league) => {
      const leagueMatchesView = league.matches
        .map(renderPrematchTableMatch)
        .join("");

      if (!leagueMatchesView) return "";

      return `
        <div class="singleHeaderHolderLabel fourColumn todayMatchesLeagueHeader">
          <div class="singleHeaderLabel">${league.name}</div>
          <div class="singleHeaderLabel">1</div>
          <div class="singleHeaderLabel">x</div>
          <div class="singleHeaderLabel">2</div>
        </div>
        ${leagueMatchesView}`;
    })
    .join("");
}

let Landing = {
  render: async () => {
    const blockedSports = JSON.parse(localStorage.getItem('blockedSports') ?? '[]');
    const sport_id = 1;
    const blockedFootball = blockedSports.indexOf(sport_id.toString()) !== -1;

    // if (LOGIN_PROTECTED === true && !localStorage.getItem("access_token")) {
    //   return "";
    // }

    let featuredPrematchs = blockedFootball ? [] : await getFeaturedMatches(sport_id);
    const todayMatches = blockedFootball ? [] : (await getTodayMatches()) || [];
    const featuredPrematchView = (featuredPrematchs || [])
      .map(renderFeaturedMatch)
      .join("");
    const todayMatchesView = renderTodayMatchesByLeague(todayMatches);

    let sportsView = "";
    if (sports) {
      sports.forEach((sport, i) => {
        if (sport && (sport.id != 13 || sport.id != 15)) {
          sportsView =
            sportsView +
            `<a href="#/categories/${sport.id}" sportid="${sport.id}" class="betModuleSportBtn active hd-${sport.name}">
          <i class="sport-${sport.name}"></i>
          <span>${_t(sport.name)}</span>
        </a>`;
        }
      });
    }

    let topFiveLeagues = blockedFootball ? Promise.resolve() : getTopFiveLeagues().then((value) => {
      let getTopFiveLeaguesView = "";
      value.forEach((topFiveLeague) => {
        getTopFiveLeaguesView =
          getTopFiveLeaguesView +
          `<a class="leagueListContentItem" href="#/games/${topFiveLeague.id}" data-id="${topFiveLeague.id}">${topFiveLeague.name}</a>`;
      });

      document.getElementById("leagueHeaderContentF").innerHTML =
        getTopFiveLeaguesView;

      updateMatch();
    });

    let topTenMatchGames = blockedFootball ? Promise.resolve() : getTopTenMatchGames().then((value) => {
      let getTopTenMatchGamesView = "";
      value.forEach((topTenMatchGame) => {
        if (!topTenMatchGame.odd) {
          return;
        }
        getTopTenMatchGamesView =
          getTopTenMatchGamesView +
          `<div class="singleGameContent">
                           <a class="singleTeamNames" href="#/Match/${
                             topTenMatchGame.id
                           }" data-id="${topTenMatchGame.id}">
                               <div class="singleDateColumn">
                                  <span>${topTenMatchGame.game_time.split(":")[0]}:${topTenMatchGame.game_time.split(":")[1]}</span>
                        <span class="numberofmarkets">${topTenMatchGame.count_options} ></span>
                               </div>
                               <div class="singleDetailsColumn">
                                 <div class="singleTeamRowLabel">
                                   <span class="singleHomeName">${
                                     topTenMatchGame.home_team
                                   }</span>
                                   <span class="gameSingleHomeScore"></span>
                                 </div>
                                 <div class="singleTeamRowLabel">
                                   <span class="singleAwayName">${
                                     topTenMatchGame.away_team
                                   }</span>
                                   <span class="gameSingleAwayScore"></span>
                                 </div>
                               </div>
                           </a>
                           <div class="singleHomeOdd bettingBtn  ${Math.floor((parseFloat(topTenMatchGame.odd.split(",")[0].split("|")[1]) + Number.EPSILON) * 100) / 100 == 1 ? "disabledBtn" : ""} ${
                             topTenMatchGame.odd.split(",")[0].split("|")[0]
                           }" match-odd="${
                             Math.floor(
                               (parseFloat(
                                 topTenMatchGame.odd
                                   .split(",")[0]
                                   .split("|")[1],
                               ) +
                                 Number.EPSILON) *
                                 100,
                             ) / 100
                           }" match-home-name="${topTenMatchGame.home_team}" match-away-name="${
                             topTenMatchGame.away_team
                           }" match-market="Rezultat Final"  match-market-option="1 " coef-id="${
                             topTenMatchGame.odd.split(",")[0].split("|")[0]
                           }" bet-id="${
                             topTenMatchGame.odd.split(",")[0].split("|")[0]
                           }" game-id="${topTenMatchGame.id}">${(
                             Math.floor(
                               (parseFloat(
                                 topTenMatchGame.odd
                                   .split(",")[0]
                                   .split("|")[1],
                               ) +
                                 Number.EPSILON) *
                                 100,
                             ) / 100
                           ).toFixed(2)}</div>
                           <div class="singleDrawOdd bettingBtn  ${Math.floor((parseFloat(topTenMatchGame.odd.split(",")[1].split("|")[1]) + Number.EPSILON) * 100) / 100 == 1 ? "disabledBtn" : ""}  ${
                             topTenMatchGame.odd.split(",")[1].split("|")[0]
                           }" match-odd="${(
                             Math.floor(
                               (parseFloat(
                                 topTenMatchGame.odd
                                   .split(",")[1]
                                   .split("|")[1],
                               ) +
                                 Number.EPSILON) *
                                 100,
                             ) / 100
                           ).toFixed(
                             2,
                           )}" match-home-name="${topTenMatchGame.home_team}" match-away-name="${
                             topTenMatchGame.away_team
                           }" match-market="Rezultat Final"  match-market-option="X " coef-id="${
                             topTenMatchGame.odd.split(",")[1].split("|")[0]
                           }" bet-id="${
                             topTenMatchGame.odd.split(",")[1].split("|")[0]
                           }" game-id="${topTenMatchGame.id}">${(
                             Math.floor(
                               (parseFloat(
                                 topTenMatchGame.odd
                                   .split(",")[1]
                                   .split("|")[1],
                               ) +
                                 Number.EPSILON) *
                                 100,
                             ) / 100
                           ).toFixed(2)}</div>
                           <div class="singleAwayOdd bettingBtn  ${(Math.floor((parseFloat(topTenMatchGame.odd.split(",")[2].split("|")[1]) + Number.EPSILON) * 100) / 100).toFixed(2) == 1 ? "disabledBtn" : ""} ${
                             topTenMatchGame.odd.split(",")[2].split("|")[0]
                           }" match-odd="${(
                             Math.floor(
                               (parseFloat(
                                 topTenMatchGame.odd
                                   .split(",")[2]
                                   .split("|")[1],
                               ) +
                                 Number.EPSILON) *
                                 100,
                             ) / 100
                           ).toFixed(
                             2,
                           )}" match-home-name="${topTenMatchGame.home_team}" match-away-name="${
                             topTenMatchGame.away_team
                           }" match-market="Rezultat Final"  match-market-option="2 " coef-id="${
                             topTenMatchGame.odd.split(",")[2].split("|")[0]
                           }" bet-id="${
                             topTenMatchGame.odd.split(",")[2].split("|")[0]
                           }" game-id="${topTenMatchGame.id}">${(
                             Math.floor(
                               (parseFloat(
                                 topTenMatchGame.odd
                                   .split(",")[2]
                                   .split("|")[1],
                               ) +
                                 Number.EPSILON) *
                                 100,
                             ) / 100
                           ).toFixed(2)}</div>
                         </div>`;
      });

      document.getElementById("getTopTenMatchGamesViewF").innerHTML =
        getTopTenMatchGamesView;

      updateMatch();
    });
    let topTenLiveGames = blockedFootball ? Promise.resolve() : getTopTenLiveGames().then((value) => {
      let getTopTenLiveGamesView = "";

      value.forEach((topTenLiveGame) => {
        if (topTenLiveGame.id != 372481) {
          getTopTenLiveGamesView =
            getTopTenLiveGamesView + getLiveTemplate(topTenLiveGame);

          const check = timers.find((a) => a.game_id == topTenLiveGame.id);
          const timerId = setInterval(
            () => liveTimer(`${topTenLiveGame.id}-timer`),
            1000,
          );
          if (check) {
            clearInterval(check.timerId);
            check.timerId = timerId;
          } else {
            timers.push({
              game_id: topTenLiveGame.id,
              timerId,
            });
          }
        }
      });
      document.getElementById("getTopTenLiveGamesViewF").innerHTML =
        getTopTenLiveGamesView;

      updateMatch();
    });

    const slotsUrl = !isEuroVegasDomain ? '#/deluxe' : '#/vegas?category=vegas_games';

    let view = /*html*/ `
          <div class="pageSection">
              <div class="firstColumn">
                <div class="betModule liveInModule sportsLanding">
                    <div class="betModuleTabs">
                    <div class="betModuleTabsBtn">
                        ${sportsView}
                    </div>
                    </div>
                </div>
                <div class="gamesSection">
                    <div class="slotsWrapper">
                        <div class="slotsHolderScroll">
                            <div class="scrollHelper100">
                                <a class="slotsItem virtual" onclick="launchvirtualgames()">
                                    <img src="img/KenoAustria.png" loading="lazy" alt="" />
                                    <span>keno austria</span>
                                </a>
                                <a class="slotsItem virtual" onclick="launchvirtualgames()">
                                    <img src="img/dograce.jpeg" loading="lazy" alt="" />
                                    <span>Racing Dogs</span>
                                </a>
                                <a class="slotsItem virtual" onclick="launchvirtualgames()">
                                    <img src="img/lucky.jpg" alt="" loading="lazy" />
                                    <span>Lucky Balls</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="gamesSection">
                    <div class="center">
                        <div>
                            <a href="${slotsUrl}">
                                <img src="img/egt_digital_reklama.gif" alt="" />
                                <span>Top Game</span>
                            </a>
                        </div>
                        <div>
                        <a href="${slotsUrl}">
                            <img src="img/GatesofOlympus.jpg" alt="" />
                            <span>Top Game</span>
                            </a>
                        </div>
                        <div>
                        <a href="${slotsUrl}">
                            <img src="img/sizzlinghotdeluxe.jpg" alt="" />
                            <span>Top Game</span>
                            </a>
                        </div>
                        <div>
                        <a href="${slotsUrl}">
                            <img src="img/SweetBonanza.jpg" alt="" />
                            <span>Top Game</span>
                            </a>
                        </div>
                        <div>
                        <a href="${slotsUrl}">
                            <img src="img/bookofradeluxe6.jpg" alt="" />
                            <span>Top Game</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="padding-boddy">
                <div class="betModule liveInModule accordionDisable">
                    <div class="betModuleHeaderContainer"> 
                        <a class="betModuleHeaderBtn">
                            <span>${_t("Ndeshjet Kryesore")}</span>
                            <span class="yellowColored"></span>
                        </a>
                        <a class="betHeaderEventBtn" href="#/inPlay"></a>
                    </div>
                </div>
                <div class="featuredPrematchWrapper">
                    <div class="featuredPrematchSlider">
                        ${featuredPrematchView}
                    </div>            
                </div>
                ${
                  blockedFootball
                    ? ""
                    : `
                <div class="betModule liveInModule">
                    <div class="betModuleHeaderContainer" id="todayAccordion" role="button" tabindex="0" aria-expanded="false" aria-controls="todayAccordionContent">
                        <a class="betModuleHeaderBtn">
                            <span>${_t("Ndeshjet Sot")}</span>
                            <span class="yellowColored"></span>
                        </a>
                        <a class="betHeaderEventBtn">
                            <svg class="arrowDownIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 451.847 451.847" aria-hidden="true">
                                <path d="M225.923,354.706c-8.098,0-16.195-3.092-22.369-9.263L9.27,151.157c-12.359-12.359-12.359-32.397,0-44.751c12.354-12.354,32.388-12.354,44.748,0l171.905,171.915l171.906-171.909c12.359-12.354,32.391-12.354,44.744,0c12.365,12.354,12.365,32.392,0,44.751L248.292,345.449c-6.177,6.172-14.274,9.257-22.369,9.257z"/>
                            </svg>
                        </a>
                    </div>
                    <div class="todayMatchesAccordionContent" id="todayAccordionContent" style="display: none;">
                        <div class="betModuleContentContainer">
                            <div class="betModuleSportAccordion moduleFirstColour soccerTab">
                                <div class="moduleSportAccordionContent">
                                    <div class="moduleSportSingleAccordion">
                                        <div class="moduleSportSingleLeague">
                                            <div class="moduleSportSingleLeagueContent gameTableContent">
                                                ${todayMatchesView}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                `
                }
                
                    <div class="betModule liveInModule accordionDisable">
                    <div class="betModuleHeaderContainer">
                    <a class="betModuleHeaderBtn">
                        <strong style="font-size: 21px"><span>${_t("NE KOHE")}</span>
                        <span class="yellowColored">${_t("REALE")}</span></strong>
                    </a>
                    <a class="betHeaderEventBtn" href="#/inPlay">
                        <svg class="arrowDownIcon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="451.847px" height="451.847px" viewBox="0 0 451.847 451.847" style="enable-background:new 0 0 451.847 451.847;" xml:space="preserve">
                            <g>
                            <path d="M225.923,354.706c-8.098,0-16.195-3.092-22.369-9.263L9.27,151.157c-12.359-12.359-12.359-32.397,0-44.751   c12.354-12.354,32.388-12.354,44.748,0l171.905,171.915l171.906-171.909c12.359-12.354,32.391-12.354,44.744,0   c12.365,12.354,12.365,32.392,0,44.751L248.292,345.449C242.115,351.621,234.018,354.706,225.923,354.706z"/>
                            </g>
                        </svg>
                    </a>
                    </div>
                    <div class="singleHeaderHolderLabel fourColumn">
                        <div class="singleHeaderLabel">${_t("Soccer")}</div>
                        <div class="singleHeaderLabel">1</div>
                        <div class="singleHeaderLabel">x</div>
                        <div class="singleHeaderLabel">2</div>
                        </div>
                    <div class="betModuleContentContainer">
                    <div class="betModuleSportAccordion moduleFirstColour soccerTab">
                        <div class="moduleSportAccordionContent">
                        <div class="moduleSportSingleAccordion">
                            <div class="moduleSportSingleLeague">
                            <div class="moduleSportSingleLeagueContent gameTableContent" id="getTopTenLiveGamesViewF">
                            </div>
                            <a class="view-all-row" href="#/inPlay">
                                <span>${_t("Shiko te gjitha ne kohe reale")}</span>
                                <span>${_t("Te gjitha ndeshjet")}</span>
                            </a>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                <div class="gameTableHeader">
                        <span>${_t("Futboll")}</span>
                        <span class="gameTableHeaderTitle">${_t("Ndeshjet ne vijim")}</span>
                    </div>
                    <div class="singleHeaderHolderLabel fourColumn">
                        <div class="singleHeaderLabel">Soccer</div>
                        <div class="singleHeaderLabel">1</div>
                        <div class="singleHeaderLabel">x</div>
                        <div class="singleHeaderLabel">2</div>
                        </div>
                    <div class="gameTableContent">
                        <div class="gameTableContent" id="getTopTenMatchGamesViewF">
                                                </div>
                    </div>

                    <div class="betModule liveInModule boldone accordionDisable">
                        <div class="betModuleHeaderContainer makeFull">
                        <a class="betModuleHeaderBtn">
                            <span>${_t("Kampionatet kryesore")}</span>
                            <span class="yellowColored"></span>
                        </a>
                        </div>
                    </div>
                    <div class="leagueHeaderContent" id="leagueHeaderContentF">
                    </div>
                    </div>
            </div>
       `;

    return view;
  },
  after_render: async (socket) => {
    // if (LOGIN_PROTECTED === true && !localStorage.getItem("access_token")) {
    //   return;
    // }

    $("body .center").not(".slick-initialized").slick({
      centerMode: true,
      variableWidth: true,
      slidesToShow: 1,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 2000,
      infinite: true,
    });

    let scrollVar4 = 0;
    $("body .scrollHelper100")
      .children(".slotsItem")
      .each(function (i, item) {
        scrollVar4 += $(item).outerWidth() + 15;
      });

    $("body .scrollHelper100").css({
      width: scrollVar4 + 15 + "px",
    });

    $("body").on("click", ".sliderItemCasino", async function (e) {
      const event = new CustomEvent("loadLiveCasino", {});
      window.dispatchEvent(event);
    });

    $("body")
      .off("click.todayMatchesAccordion", "#todayAccordion")
      .on("click.todayMatchesAccordion", "#todayAccordion", function (e) {
        e.preventDefault();

        const expanded = $(this).attr("aria-expanded") === "true";
        $(this)
          .toggleClass("rotate", !expanded)
          .attr("aria-expanded", String(!expanded));
        $("#todayAccordionContent").stop(true, true).slideToggle(200);
      });

    $("body")
      .off("keydown.todayMatchesAccordion", "#todayAccordion")
      .on("keydown.todayMatchesAccordion", "#todayAccordion", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          $(this).trigger("click");
        }
      });

    socket.emit("connectToRoom", { room: "prematch-games" });
    socket.emit("connectToRoom", { room: "inplay" });
    $("body .menuItem a").removeClass("active");
    $("body .mainLeftMenuItem a").removeClass("active");
    $("body #inPlayPage").removeClass("active");
    $("body .leftMenuHome ").addClass("active");
    $("body .homeLeftBtn").addClass("active");
    $("body .betModuleTabs").css({
      width: $(".betModuleTabs .betModuleTabsBtn a:visible").length * 77 + "px",
    });
    $("body .featuredPrematchWrapper").each(function () {
      let featuredSliderWidth = 0;
      $(this)
        .children(".featuredPrematchSlider")
        .children(".featuredPrematchItem")
        .each(function () {
          featuredSliderWidth += $(this).outerWidth() + 2;
        });
      $(this)
        .children(".featuredPrematchSlider")
        .css({
          width: featuredSliderWidth - 3 + "px",
        });
    });

  },
  on_unload: async (socket) => {
    socket.emit("leaveRoom", { room: "prematch-games" });
    socket.emit("leaveRoom", { room: "inplay" });
    timers.forEach((timer) => clearInterval(timer.timerId));
  },
};

function liveTimer(id) {
  const current_minute = $(`#${id}`).text();
  if (!current_minute || current_minute == "" || current_minute == "45:00")
    return;
  let minutes = parseInt(current_minute.split(":")[0]);
  let seconds = parseInt(current_minute.split(":")[1]);

  if (seconds == 59) {
    minutes += 1;
    seconds = 0;
  } else seconds += 1;

  $(`#${id}`).text(
    `${minutes < 10 ? `0${minutes}` : minutes}:${
      seconds < 10 ? `0${seconds}` : seconds
    }`,
  );
}

export default Landing;
